/*
 *   File : primary-button.js
 *   Author : https://evoqins.com
 *   Description : CTA component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

// Assets 
import Loader from "../../Assets/Images/loader-light.gif";

//Custom components
import { Icon } from '../Icon';

const PrimaryButton = (props) => {

    return (
        <button className={`e-padding-8px-tb-12px-lr-res ${props.className} ${props.status ? `px-4 padding-10px-tb` :
            `${props.padding ? props.padding : "px-3"} padding-14px-tb`} 
             ${props.type === 2 ? 'e-cursor-none' : ''}
            ${props.disabled === true ? 'opacity-75' : ''}
            ${props.fontSize ? props.fontSize : "e-font-14"}
             ${props.fontWeight ? props.fontWeight : "e-font-weight-600"} border-radius-8 border-0  e-bg-gradient-btn border-transparent e-alt-font-lato e-text-white line-height-20px`}

            data-bs-toggle={props.toggle}
            data-bs-target={props.target}
            data-bs-cancel={props.cancel}
            data-bs-dismiss={props.dismiss}
            disabled={props.type !== 2 ? props.disabled : false}
            id={props.id}
            onClick={(e) => props.onPress(e)}>

            {props.status ?
                <img src={Loader}
                    className={`${props.loaderClass} w-20px h-20px my-1`} //margin-2px-block
                    alt='loader' />
                :
                <div className='d-flex align-items-center gap-2 justify-content-center text-nowrap'>
                    {props.icon === true &&
                        <Icon icon={props.type === "logout" ? "logout" : "plus-icon"}
                            className="d-flex"
                            color={props.iconColor ? props.iconColor : ""}
                            size={props.type === "logout" ? "20px" : "12px"} />
                    }
                    <span>{props.name}</span>
                </div>
            }
        </button>
    )
}

PrimaryButton.defaultProps = {
    onPress: () => { },
    className: null,
    id: null,
    name: null,
    icon: null
};

export default memo(PrimaryButton);